export default __webpack_public_path__ + "static/media/token_right.9fdbe6e6.png";